/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { css, jsx } from '@emotion/core';
import { Colors, Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';

const Styles = {
  link: css`
    display: block;
    width: 100%;
  `,
  text: (isActive: boolean) => [
    css`
      padding: 15px 0 15px 35px;
    `,
    isActive &&
      css`
        background-color: ${Colors.UiPrimaryStrongest};
      `,
  ],
};

type Props = PropsWithChildren<{
  href: string;
  isActive: boolean;
}>;

const SidebarLink = ({ href, isActive, children }: Props) => {
  return (
    <Link href={href} css={Styles.link}>
      <Text
        color={isActive ? 'PrimeWhite' : undefined}
        css={Styles.text(isActive)}
        tag="div"
      >
        {children}
      </Text>
    </Link>
  );
};

export default SidebarLink;
